'use client';

import type { WebshopProduct } from '@cldsystems/ws-api-client';
import { FC } from 'react';
import { ArrayElement } from '@/types/common';
import DescriptionTab from '../description-tab/description-tab';
import AttributeGroupTable from './attribute-group/attribute-group-table';

type AttributeGroup = ArrayElement<
  WebshopProduct['categoryAttributeGroups' | 'productAttributeGroups']
>;

type Props = {
  categoryAttributeGroups: AttributeGroup[];
  productAttributeGroups: AttributeGroup[];
  secondaryDescription?: string | null;
};

const DetailsTab: FC<Props> = ({
  categoryAttributeGroups,
  productAttributeGroups,
  secondaryDescription,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <DescriptionTab description={secondaryDescription ?? ''} />
      {categoryAttributeGroups && (
        <>
          {categoryAttributeGroups.map((item: AttributeGroup) => (
            <div key={item.id} className="flex flex-col gap-2">
              <AttributeGroupTable attributeGroup={item} />
            </div>
          ))}
        </>
      )}
      {productAttributeGroups && (
        <>
          {productAttributeGroups.map((item: AttributeGroup) => (
            <div key={item.id} className="flex flex-col gap-2">
              <AttributeGroupTable attributeGroup={item} />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default DetailsTab;
